import { IRender } from '../parseTreeToHtml.types';

export const textRender: IRender = (text): string => {
  return text;
};
